import { uploadThemeMedia } from "../../functions/uploadThemeMedia";
import { renameFileForUpload } from "./safeUploadFileName";
import { QUIZ_IMAGE_DIMENSIONS } from "./imageDimensions";

const QUIZ_IMAGE_MAX_MB = 5;
const QUIZ_IMAGE_EXT = ["jpg", "jpeg", "png", "gif"];

export const QUIZ_IMAGE_FIELD = "quiz_question_image";
export const QUIZ_IMAGE_HINT = `JPG, PNG or GIF · exactly ${QUIZ_IMAGE_DIMENSIONS[0]}×${QUIZ_IMAGE_DIMENSIONS[1]} px · max ${QUIZ_IMAGE_MAX_MB} MB`;

export function validateQuizImageFile(file) {
  if (!file) return { ok: false, message: "Please choose an image." };
  const ext = (file.name.split(".").pop() || "").toLowerCase();
  if (!QUIZ_IMAGE_EXT.includes(ext)) {
    return {
      ok: false,
      message: `Unsupported format for ${file.name}. Use JPG, PNG or GIF.`,
    };
  }
  if (file.size > QUIZ_IMAGE_MAX_MB * 1024 * 1024) {
    return { ok: false, message: `${file.name} exceeds ${QUIZ_IMAGE_MAX_MB}MB.` };
  }
  return { ok: true };
}

/**
 * Upload a quiz question image to S3 (upload-only — nothing is written to the theme here).
 * Returns the stored filename to save as the question's `question_image`.
 */
export async function uploadQuizImageFile({
  file,
  adminToken,
  currentTheme,
  organizationId,
  sessionId,
}) {
  const check = validateQuizImageFile(file);
  if (!check.ok) throw new Error(check.message);

  const formData = new FormData();
  formData.append("themeName", currentTheme);
  formData.append("organizationId", organizationId || "admin");
  formData.append("sessionId", sessionId || "admin");
  formData.append("uploadOnly", "true");
  formData.append(QUIZ_IMAGE_FIELD, renameFileForUpload(file, "question"));

  const data = await uploadThemeMedia({ formData, token: adminToken });
  const filename = data?.uploaded_files?.[QUIZ_IMAGE_FIELD];
  if (!filename) {
    throw new Error("Image upload failed — no filename returned from server.");
  }
  return filename;
}
